export CommentList from './CommentList';



// WEBPACK FOOTER //
// ../src/client/components/comments/index.js